<template>
  <v-container ma-0 px-4 mb-4 pt-2 style="max-width:100%;">
    <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  Tasks - 25
                </h2>
              </template>
                <span>Metrics Dashboard</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header font-weight-bold error--text d-inline-block pr-3">Overdue - <span class="font-weight-bold">5</span></h4>
            <h4 class="pt-1 sub-header d-inline-block pr-3">Due today - <span class="font-weight-bold">5</span></h4>
             <h4 class="pt-1 sub-header d-inline-block pr-3">Due this week - <span class="font-weight-bold">5</span></h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>
    <v-btn
      :ripple="false"
      flat
      class="ml-0 mb-2 pt-0 search-button"
      v-on:click="searchToggled = !searchToggled"
    >
      <v-icon color="secondary" class="mr-2 mt-0">{{ searchToggled ? 'close' : 'search' }}</v-icon>
      {{ searchToggled ? 'Search/Filter' : 'Search/Filter' }}
    </v-btn>
    <v-slide-y-transition>
      <v-layout row fluid wrap v-if="searchToggled">
        <v-layout row wrap fluid>
          <v-flex xs12 md4 class="pr-4">
            <h4>Task Owner</h4>
            <v-radio-group v-model="radioGroupOwner" class="pa-0 ma-0 mt-2">
              <v-radio class="mb-2 mr-4" color="secondary" label="All" value="All"></v-radio>
              <v-radio class="mb-2 mr-4" color="secondary" label="My Tasks" value="My"></v-radio>
              <v-radio class="mb-2 mr-4" color="secondary" label="My Team Tasks" value="Team"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 md4 class="pr-4">
            <h4>Task Scheduling</h4>
            <v-radio-group v-model="radioGroupType" class="pa-0 ma-0 mt-2">
              <v-radio class="mb-2 mr-4" color="secondary" label="All" value="All"></v-radio>
              <v-radio class="mb-2 mr-4" color="secondary" label="Overdue" value="Overdue"></v-radio>
              <v-radio class="mb-2 mr-4" color="secondary" label="Unscheduled" value="unscheduled"></v-radio>
              <v-radio class="mb-2 mr-4" color="secondary" label="Scheduled" value="Scheduled"></v-radio>
              <v-radio
                class="mb-2 mr-4"
                color="secondary"
                label="Scheduled Today"
                value="Scheduled Today"
              ></v-radio>
              <v-radio
                class="mb-2"
                color="secondary"
                label="Scheduled This Week"
                value="Scheduled This Week"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 md4 class="pr-4">
            <h4>Task Status</h4>
            <v-radio-group v-model="radioGroupType" class="pa-0 ma-0 mt-2">
              <v-radio class="mb-2 mr-4" color="secondary" label="All" value="All"></v-radio>
              <v-radio class="mb-2 mr-4" color="secondary" label="Never run" value="never"></v-radio>
              <v-radio class="mb-2 mr-4" color="secondary" label="Complete" value="complete"></v-radio>
              <v-radio class="mb-2 mr-4" color="secondary" label="Failed" value="failed"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <v-layout style="width:100%;" row wrap class="mt-3 mb-0">
          <v-flex xs6 md4 class="pr-0">
            <v-text-field
              box
              clearable
              ref="searchInput"
              color="secondary"
              clear-icon="cancel"
              id="buckets-search-text"
              label="Search for..."
              placeholder="Type your search here"
              v-model="searchTermModel"
              @keydown.enter="searchTerm = searchTermModel"
              class="remove-top-right-border-radius"
            >
              <template slot="append">
                <v-icon>search</v-icon>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex xs6 md4 style="margin-left:-0px;" class="pl-0 pt-0">
            <v-select
              box
              label="within..."
              :items="searchableFields"
              v-model="selectedField"
              placeholder="All Fields"
              color="secondary"
              clear-icon="cancel"
              append-icon="keyboard_arrow_down"
              class="remove-top-left-border-radius"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-slide-y-transition>
    <v-layout>
      <v-data-table
        :headers="headers"
        :items="assignedTasks"
        class="my-custom-table box-shadow"
        style="width:100%;display:table"
      ></v-data-table>
    </v-layout>
    <span>
      The Scheduled Cell, will either be empty if not scheduled; Have the schduled date and time with either 'At' or 'By'; or be overdue which will have the time it is overdue. Overdue task I think we need to make the text in this cell red and bold, as per the task tile
    </span>
  </v-container>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "TasksTable",
  components: {},
  computed: {
    ...mapState({
      allTeams: state => state.teams.all
    }),
    assignedTasks() {
      const tasks = []
      for (const team of (this.allTeams || [])) {
        for (const assignedTask of team.assignedTasks) {
          tasks.push(assignedTask)
        }
      }
      return tasks
    }
  },
  data: () => {
    return {
      radioGroupOwner: "All",
      radioGroupType: "All",
      searchableFields: [
        "All fields",
        "Task name",
        "Scheduled",
        "Case Title",
        "Status"
      ],
      selectedField: "All fields",
      searchToggled: false,
      headers: [
        {
          text: "Task Name",
          align: "left"
        },
        {
          text: "Assigned To",
          align: "left"
        },
        {
          text: "Scheduled",
          align: "left"
        },
        {
          text: "Status",
          align: "left"
        },
        {
          text: "Case Title",
          align: "left"
        },
        {
          text: "Case Template",
          align: "left"
        }
      ]
    }
  }
}
</script>
